import React from "react";
import PageHeader from "../components/PageHeader";
import CrudTable from "../components/CrudTable";

export default function Products() {
  const columns = [
    { key: "urun_kodu", label: "Ürün Kodu", mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", mono: true },
    { key: "aciklama", label: "Açıklama" },
    { key: "is_bolumu", label: "İş Bölümü" },
    { key: "renk", label: "Renk" },
    { key: "makina", label: "Makine" },
    { key: "firin_bolgesi", label: "Fırın Bölgesi" },
    { key: "urun_kg", label: "Kğ Ağırlık", num: true },
    { key: "satis_noktasi", label: "Satış Noktası" },
  ];
  const fields = [
    { key: "urun_kodu", label: "Ürün Kodu", type: "text", required: true, mono: true },
    { key: "kalip_kodu", label: "Kalıp Kodu", type: "text", mono: true },
    { key: "aciklama", label: "Açıklama", type: "text", span: 2 },
    { key: "is_bolumu", label: "İş Bölümü", type: "text" },
    { key: "renk", label: "Renk", type: "text" },
    { key: "makina", label: "Makine", type: "text" },
    { key: "firin_bolgesi", label: "Fırın Bölgesi", type: "text" },
    { key: "urun_kg", label: "Kğ Ağırlık", type: "number" },
    { key: "satis_noktasi", label: "Satış Noktası", type: "text" },
  ];
  return (
    <>
      <PageHeader title="Malzemeler" subtitle="Ürün kodu, kalıp kodu, iş bölümü, renk, makine ve ağırlık tanımları" />
      <CrudTable endpoint="/products" columns={columns} fields={fields} titleSingular="Malzeme" printTitle="Malzemeler" exportKind="products" adminOnlyEdit
        bulkEditFields={["urun_kg", "firin_bolgesi", "is_bolumu", "renk", "makina", "satis_noktasi", "kalip_kodu", "aciklama"]} />
    </>
  );
}
